<label [attr.for]="inputId"
       #label
       class="flex cursor-pointer"
       [ngClass]="top ? 'flex-top' : 'flex-middle'">

    <input #input
           class="visually-hidden"
           [id]="inputId"
           type="radio"
           [required]="required"
           [checked]="checked"
           [attr.value]="value"
           [disabled]="disabled"
           [attr.name]="name"
           [attr.aria-label]="ariaLabel || null"
           [attr.aria-labelledby]="ariaLabelledby"
           (change)="onInputChange($event)">

    <i [ngClass]="checked ? 'icon-radio-on' : 'icon-radio-off'"
       [class.radio__icon--top]="top"
       class="col-1 radio__icon flex flex-middle"></i>

    <div class="radio__content flex-grow flex flex-middle m-l">
        <!-- Use either radioBody to have own stylijng or regular content to have default one -->
        <ng-content select="[radioBody]"></ng-content>
        <span class="p1">
            <ng-content></ng-content>
        </span>
    </div>

</label>
